import moment from 'moment-timezone'
import date from './date.js'

export default{
    async lastSuggestions(suggestions){
        // ultima sugestão de de cada player em cada letra

        // separar suggestions de cada letra
        let objectLetter = await this.separeLetter(suggestions)
        // Separar sugestões de cada candidato dentro de cada letra
        let objectPlayer = await this.separeCandidate(objectLetter)
        // Filtrar apenas as tentativas mais recentes de cada candidato dentro de cada letra
        let objectLast = await this.filterLastSuggestion(objectPlayer)

        return objectLast
    },
    separeLetter(suggestions){ // separar suggestions de cada letra
        let objectLetter = {
            a : [],
            b : [],
            c : []
        }

        if(suggestions){
            suggestions.forEach(suggestion => {
                objectLetter[suggestion.enigmaOrder].push(suggestion)
            })
        }
        
        return objectLetter
    },
    separeCandidate(objectLetter){ // Separar sugestões de cada candidato dentro de cada letra

        let objectPlayer = {
            a : {},
            b : {},
            c : {}
        }

        for(var letter in objectLetter){
            objectLetter[letter].forEach(suggestion => {
                if(!objectPlayer[letter][suggestion.userId]){
                    objectPlayer[letter][suggestion.userId] = []
                }
                objectPlayer[letter][suggestion.userId].push(suggestion)
            })
        } 
        return objectPlayer
    },
    filterLastSuggestion(objectPlayer){ // Filtrar apenas as tentativas mais recentes de cada candidato dentro de cada letra
        for(var letter in objectPlayer){ 
            for(var player in objectPlayer[letter]){
                if(objectPlayer[letter][player].length > 1){
                    objectPlayer[letter][player].forEach((suggestion,index) => {
                        objectPlayer[letter][player][index].createdAt = date.timestampToMoment(suggestion.createdAt)
                    })
                    let newObject = objectPlayer[letter][player].reduce((a,b) => {
                        return Date.parse(a.createdAt) > Date.parse(b.createdAt) ? a : b
                    })
                    objectPlayer[letter][player] = [newObject]
                }
            }
        }
        return objectPlayer
    },
    selfPlayer(group){
        let selfId = localStorage.getItem('userId')
        let selfPlayer = group.filter(user => {
            return user.id == selfId
        })
        return selfPlayer[0]
    }
}
    
